/**
 * @module app.tooltip.conditiongrade
 */
class Controller {
  /**
   * @ngInject
   */
  constructor() {
    /**
     * @export
     * @const {string}
     */
    this.categoryCondition;

    /**
     * @export
     * @const {string}
     */
    this.categoryConditionText;

    /**
     * @export
     * @const {string}
     */
    this.categoryGrade;

    /**
     * @export
     * @const {string}
     */
    this.categoryGradeText;
  }

  /**
   * @export
   * @return {boolean}
   */
  hasOnlyCategoryCondition() {
    return this.hasCategoryCondition_() && !this.hasCategoryGrade_();
  }

  /**
   * @export
   * @return {boolean}
   */
  hasOnlyCategoryGrade() {
    return !this.hasCategoryCondition_() && this.hasCategoryGrade_();
  }

  /**
   * @export
   * @return {boolean}
   */
  hasBoth() {
    return this.hasCategoryCondition_() && this.hasCategoryGrade_();
  }

  /**
   * @private
   * @return {boolean}
   */
  hasCategoryCondition_() {
    return !!this.categoryCondition;
  }

  /**
   * @private
   * @return {boolean}
   */
  hasCategoryGrade_() {
    return !!this.categoryGrade;
  }
}

/**
 * @const {!angular.Component}
 */
const component = {
  controller: Controller,
  templateUrl: 'partials/tooltip/mixins/condition-grade.html',
  bindings: {
    'categoryCondition': '<',
    'categoryConditionText': '<',
    'categoryGrade': '<',
    'categoryGradeText': '<'
  }
};

const name = 'appTooltipConditiongrade';

export default angular.module(name, []).component(name, component);
